function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
var NoScroll = css(["-ms-overflow-style:none;&::-webkit-scrollbar{display:none;width:0 !important;}"]);
var Wrapper = styled.div.withConfig({
  displayName: "ScrollablePanel__Wrapper"
})(["display:flex;flex-grow:1;overflow-x:hidden;overflow-y:", ";-webkit-overflow-scrolling:touch;", ";"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? "hidden" : "scroll";
}, function (_ref2) {
  var removeScrollbar = _ref2.removeScrollbar;
  return removeScrollbar && NoScroll;
});
var ContentWrapper = styled.div.withConfig({
  displayName: "ScrollablePanel__ContentWrapper"
})(["flex-grow:1;min-height:min-content;"]);
export var ScrollablePanel = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ScrollablePanel, _React$PureComponent);
  function ScrollablePanel() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, ScrollablePanel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollablePanel)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleScroll", function (event) {
      _this.props.onScroll(event.target.scrollTop);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "panelRef", function (panel) {
      _this.scrollingContainer = panel;
    });
    return _this;
  }
  _createClass(ScrollablePanel, [{
    key: "render",
    value: function render() {
      typeof this.props.scrollTop === "number" && this.setScrollPosition(this.props.scrollTop);
      return React.createElement(Wrapper, {
        innerRef: this.panelRef,
        className: this.props.className,
        onScroll: this.handleScroll,
        disabled: this.props.disabled,
        removeScrollbar: this.props.removeScrollbar
      }, this.props.wrapContents ? React.createElement(ContentWrapper, null, this.props.children) : this.props.children);
    }
  }, {
    key: "panelHeight",
    value: function panelHeight() {
      return this.scrollingContainer ? this.scrollingContainer.innerHeight || this.scrollingContainer.clientHeight : 0;
    }
  }, {
    key: "scrollTop",
    value: function scrollTop() {
      return this.scrollingContainer ? this.scrollingContainer.scrollTop : 0;
    }
  }, {
    key: "setScrollPosition",
    value: function setScrollPosition(scrollTop) {
      if (this.scrollingContainer && scrollTop !== this.scrollingContainer.scrollTop) {
        this.scrollingContainer.scrollTop = scrollTop;
      }
    }
  }]);
  return ScrollablePanel;
}(React.PureComponent);
_defineProperty(ScrollablePanel, "propTypes", {
  className: PropTypes.string,
  removeScrollbar: PropTypes.bool,
  scrollTop: PropTypes.number,
  onScroll: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  panelRef: PropTypes.func,
  wrapContents: PropTypes.bool
});
_defineProperty(ScrollablePanel, "defaultProps", {
  onScroll: function onScroll() {},
  removeScrollbar: true,
  disabled: false,
  wrapContents: true
});